/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */

import moment from 'moment';
import 'moment-timezone';
import {
  memo, useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from '../../common/components/LocalizationProvider';
import '../../common/tickets.css';
import { useMergedTransportAtts } from '../../common/util/permissions';
import { calcDiffColor } from '../../common/util/transporte';
import { useEffectAsync } from '../../reactHelper';

const TableExistReport = ({ data }) => {
  const t = useTranslation();

  const [info, setInfo] = useState(data);
  const [toDay, setDate] = useState(null);
  const [tickets, setTickets] = useState([]);
  const devices = useSelector((state) => state.devices.items);

  const atts_for_ui = useMergedTransportAtts();

  const loadInfoTable = async () => {
    setTickets((info.ticket ?? []));
  };

  useEffect(() => {
    setDate(moment().format('YYYY-MM-D'));
  }, [toDay]);

  useEffectAsync(async () => {
    await loadInfoTable();
  }, []);



  console.log('render TableExistReport', { info, devices, tickets });
  return (
    <div>
      <div>
        <div className="nameChecker">
          {devices[info.meta.deviceId].name}
          &nbsp;|&nbsp;
          Ruta:&nbsp;
          {info.ticket[0].subroute}
        </div>
      </div>
      <div className="headerExitst">
        <div className="columns headerCol1">
          {t('referencePoint')}
        </div>
        <div className="columns headerCol2">
          {t('arrives')}
          /
          {t('exits')}
        </div>
        <div className="columns headerCol3">
          #
        </div>
      </div>
      {tickets.map((ticket) => (
        <div style={calcDiffColor(ticket, atts_for_ui)} key={`t-${ticket.id}`} className="bodyExitst">
          <div className="columns bodyCol1">
            {ticket.geofence !== null ? `${ticket.geofence}` : `${t('geofence')} - ${ticket.s.geofenceId}`}
          </div>
          <div className="columns bodyCol2">
            {('expectedTime' in ticket) ? `${t('expectedTime')}: ${moment(ticket.expectedTime).tz('America/Mexico_City').format('HH:mm:ss')}` : `${t('no-data')}`}
            <br />
            {('enterTime' in ticket) ? `${t('arrive')}: ${moment(ticket.enterTime).tz('America/Mexico_City').format('HH:mm:ss')}` : `${t('no-data')}`}
          </div>
          <div className="columns bodyCol3 strike " style={ticket.excuse != null ? { color: 'black', textDecoration: 'line-through' } : { color: 'black' }}>
            {('enterTime' in ticket) && parseInt((moment.duration(moment(ticket.enterTime).tz('America/Mexico_City').diff(moment(ticket.expectedTime).tz('America/Mexico_City')))).asMinutes(), 10)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(TableExistReport);
